import { render } from "./MapLegend.vue?vue&type=template&id=e2628df8&scoped=true&ts=true"
import script from "./MapLegend.vue?vue&type=script&lang=ts"
export * from "./MapLegend.vue?vue&type=script&lang=ts"

import "./MapLegend.vue?vue&type=style&index=0&id=e2628df8&scoped=true&lang=css"
import "./MapLegend.vue?vue&type=style&index=1&id=e2628df8&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2628df8"]])

export default __exports__